import { OnInit, OnDestroy, Component } from '@angular/core';
import { NxiRestService } from '../../services/NXI-Rest.service';

declare let dojoApp: any;

@Component({
    selector: 'dojo-billsuite-opener',
    template: ''
})
export class DojoBillSuiteOpenerComponent implements OnInit, OnDestroy {

    constructor(private nxiRestService: NxiRestService) {
    }

    ngOnInit() {
       console.log('ngOnInit Bill Suite Opener init');
       this.billSuiteOpener();
    }

    ngOnDestroy(): void {
        console.log('ngOnDestroy Bill Suite Opener');
    }

    billSuiteOpener() {
        let queryparams: any;
        if ( window.location.href.split('act=').length > 0) {
            queryparams = window.location.href.split('act=')[1];
        }
        let url = this.nxiRestService.serviceUrl + '/billpay/logon-url?logonBillpay=' + queryparams;
        if (dojoApp) {
            dojoApp.renderBillSuiteOpener(url, queryparams);
        }
    }
}
